import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        organizations: [],
        menus: [],
    },

    mutations: {
        SET_ORGANISATIONS(state, payload) {
            state.organizations = payload;
        },
        SET_MENUS(state, payload) {
            state.menus = payload;
        },
    },

    actions: {
        async organizations({ commit }, { id }) {
            const { data } = await axios.get(`/admin/sites/iiko/${ id }/organizations`);
            commit('SET_ORGANISATIONS', data);
        },
        async menus({ commit }, { id }) {
            const { data } = await axios.get(`/admin/sites/iiko/${ id }/menus`);
            commit('SET_MENUS', data);
        },
        async nomenclature({ commit }, { id }) {
            const { data } = await axios.get(`/admin/sites/iiko/${ id }/nomenclature`);
        },
    },

    getters: {}
}
